import * as React from 'react';
import { RUB_SIGN } from '../../../../constants/symbols';
import { RangeInput } from '../RangeInput';
import { SearchResultsTooltip } from '../SearchResultsTooltip';

interface IPriceDropdownProps {
  tooltipOpened: boolean;
  filterRef: React.RefObject<HTMLDivElement | null>;
  priceFrom?: number;
  priceTo?: number;
  onPriceFromChange: (value?: number) => void;
  onPriceToChange: (value?: number) => void;
  onClose(): void;
}

export const PriceDropdown: React.FC<IPriceDropdownProps> = ({
  tooltipOpened,
  filterRef,
  priceFrom,
  priceTo,
  onPriceFromChange,
  onPriceToChange,
  onClose,
}) => {
  return (
    <SearchResultsTooltip open={tooltipOpened} placement="right" hostElement={filterRef.current} onApply={onClose}>
      <div>
        <RangeInput
          min={0}
          max={999999999999}
          joined={false}
          postfix={RUB_SIGN}
          valueMin={priceFrom}
          valueMax={priceTo}
          onChangeMin={onPriceFromChange}
          onChangeMax={onPriceToChange}
        />
      </div>
    </SearchResultsTooltip>
  );
};
